import React, { useState } from "react";
//import FavoritesButton from "../Favorites/FavoritesButton";
import Calculator from "../Calculator";
import SVGWrapper from "../SVGWrapper";
import infoIcon from "../../../assets/images/icons/Quam-Icon-Info.svg";
import ModalPopup from "../ModalPopup";
import { HorizontalLine, Widths } from "../../../styles";
import CustomSelect from "../CustomSelect";
import AddToQuoteBtn from "../AddToQuoteBtn";

export default function ProductButtons({ product }) {
  const [calculatorModalOpen, setCalculatorModalOpen] = useState(false);
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [productQty, setProductQty] = useState(1);
  const [selectedVersion, setSelectedVersion] = useState(0);

  const handleCalculatorForm = (e) => {
    e.preventDefault();
    e.stopPropagation();
    !calculatorModalOpen && setCalculatorModalOpen(true);
    infoModalOpen && setInfoModalOpen(false);
  };

  const handleInfoModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    !infoModalOpen && setInfoModalOpen(true);
  };

  const increaseQty = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setProductQty(productQty + 1);
  };

  const decreaseQty = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (productQty <= 1) return;
    setProductQty(productQty - 1);
  };

  const generateQuipOptions = () => {
    if (!product.sections.product_details.is_quip_product) return null;
    if (
      !product.sections.product_details.quip_details ||
      !product.sections.product_details.quip_details.versions
    )
      return null;

    return product.sections.product_details.quip_details.versions.map(
      (version) => ({
        label: (
          <>
            <span className="font-bold mr-1">{version.version}</span>{" "}
            <span>{version.label}</span>
          </>
        ),
        value: version.version,
      }),
    );
  };

  const productDetails = product.sections.product_details;

  const quipOptions = productDetails.is_quip_product
    ? generateQuipOptions()
    : null;

  return (
    <>
      <div className="flex flex-col sm:flex-row gap-6 sm:items-end">
        {productDetails.is_quip_product && (
          <div className="text-base">
            <p className="text-sm text-black font-semibold mt-0 mb-3">
              Version
            </p>
            {quipOptions && quipOptions.length > 1 && (
              <CustomSelect
                options={quipOptions}
                className="bg-gray/32"
                onChange={setSelectedVersion}
              />
            )}
          </div>
        )}
        <div className="flex flex-col items-center justify-center gap-6">
          <p className="inline-flex gap-1.5 m-0">
            <span className="text-sm text-black font-semibold">Qty</span>
            <button
              className="cursor-pointer"
              onClick={(e) => handleInfoModal(e)}
            >
              <SVGWrapper
                src={infoIcon}
                width={Widths.icons.xsmall}
                height={Widths.icons.xsmall}
              />
            </button>
          </p>
          <div className="text-lg font-bold inline-flex gap-2">
            <button
              className="w-8 h-8 cursor-pointer"
              onClick={(e) => decreaseQty(e)}
            >
              -
            </button>
            <input
              type="text"
              className="w-12 text-center"
              value={productQty}
              name="quantity"
              onChange={(e) => setProductQty(+e.target.value)}
            />
            <button
              className="w-8 h-8 cursor-pointer"
              onClick={(e) => increaseQty(e)}
            >
              +
            </button>
          </div>
        </div>

        <AddToQuoteBtn
          product={product}
          quantity={productQty}
          label="Add To Quote"
          labelRemove="Remove"
          version={quipOptions?.[selectedVersion]?.value}
        />
      </div>
      <HorizontalLine color={`slateGray`} />

      <ModalPopup
        isOpen={calculatorModalOpen}
        handleClose={setCalculatorModalOpen}
      >
        <Calculator />
      </ModalPopup>

      <ModalPopup isOpen={infoModalOpen} handleClose={setInfoModalOpen}>
        <div>
          <p className="m-0 text-black">
            Not sure how many you need?<br /> Use our {" "}
            <button
              className="cursor-pointer text-jay-blue underline hover:no-underline font-extrabold"
              onClick={(e) => handleCalculatorForm(e)}
            >
              Coverage Calculator
            </button>
          </p>
        </div>
      </ModalPopup>
    </>
  );
}
